<template>
  <div id="publishing-reviewer-board-application">
    <div class='ipub-h1 mar-b-12'>
      Manage Volunteers
    </div>
    <ipub-row :gutter="[12, 16]">
      <ipub-col :span="2">
        <ipub-select v-model="params.journalId"
                     placeholder="Select Journal"
                     @change="changeJournal"
                     :options="journalList" />
      </ipub-col>
      <ipub-col :span="10">
        <site-search-group v-model.trim="params.keyword"
                           placeholder="Search by volunteer's name, email"
                           @search="getList()"
                           @clear="handleClear" />
      </ipub-col>
    </ipub-row>
    <div class="ipub-list-tab">
      <a @click="changeStatus('')"
         :class="['ipub-list-tab--status',params.handleList===''?'active':'']">All Status</a>
      <a @click="changeStatus('UNHANDLED')"
         :class="['ipub-list-tab--status',params.handleList==='UNHANDLED'?'active':'']">Pending</a>
      <a @click="changeStatus('ACCEPTED')"
         :class="['ipub-list-tab--status',params.handleList==='ACCEPTED'?'active':'']">Approved</a>
      <a @click="changeStatus('REFUSED')"
         :class="['ipub-list-tab--status',params.handleList==='REFUSED'?'active':'']">Declined</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  fixed
                  :empty="{icon:'iconuser'}"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:name="{record}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${record.firstName} ${record.lastName}`" />
        </template>
        <template v-slot:operator="{text}">
          <ipub-tooltip v-if="text"
                        style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text.firstName} ${text.lastName}`" />
          <template v-else>- -</template>
        </template>
        <template v-slot:status="{text}">
          <ipub-label style="width:70px;"
                      size="small"
                      v-if="text === 'REFUSED'"
                      type="danger"
                      cover>Reject</ipub-label>
          <ipub-label type="default"
                      style="width:70px;"
                      size="small"
                      v-else-if="text === 'UNHANDLED'"
                      cover>Pending</ipub-label>
          <ipub-label style="width:70px;"
                      size="small"
                      v-else-if="text === 'ACCEPTED'"
                      type="success"
                      cover>Accept</ipub-label>
        </template>
        <template v-slot:actions="{ record }">
          <template v-if="record.handle === 'UNHANDLED'">
            <ipub-tooltip class="border-right"
                          v-show="user.codeList&&user.codeList.includes('EDITOR_TASK.MANAGE_VOLUNTEER.ACCEPT')">
              <div slot="title">Accept</div>
              <ipub-icon type="iconAble"
                         @click="accept(record, 'ACCEPTED')" />
            </ipub-tooltip>
            <ipub-tooltip class="border-right"
                          v-show="user.codeList&&user.codeList.includes('EDITOR_TASK.MANAGE_VOLUNTEER.REFUSE')">
              <div slot="title">Reject</div>
              <ipub-icon type="iconDisable"
                         @click="accept(record, 'REFUSED')" />
            </ipub-tooltip>
          </template>
          <template v-else>
            <ipub-icon class="disabled-icon"
                       v-show="user.codeList&&user.codeList.includes('EDITOR_TASK.MANAGE_VOLUNTEER.ACCEPT')"
                       type="iconAble" />
            <ipub-icon class="disabled-icon"
                       v-show="user.codeList&&user.codeList.includes('EDITOR_TASK.MANAGE_VOLUNTEER.REFUSE')"
                       type="iconDisable" />
          </template>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('EDITOR_TASK.MANAGE_VOLUNTEER.DETAILS')">
            <div slot="title">Details</div>
            <ipub-icon type="iconDetails"
                       @click="detail(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Detail :isVisable="isVisableDetail"
            :inputData="inputData"
            @cancel="cancel" />
    <Reject :isVisable="showReason"
            :inputData="inputData"
            @confirm="rejectConfirm"
            @cancel="cancel" />
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="APPROVAL_OF_REVIEWER_APPLICATION"
               @send="send"
               @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
